import { render } from "./approver.vue?vue&type=template&id=50f1bca5&scoped=true&ts=true"
import script from "./approver.vue?vue&type=script&lang=ts"
export * from "./approver.vue?vue&type=script&lang=ts"

import "./approver.vue?vue&type=style&index=0&id=50f1bca5&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f1bca5"]])

export default __exports__